export default {
  zIndex: {
    popover: 5001,
    layer: 5000
  }
};
